import React, { useState, useEffect, useRef } from "react";
import { Folder, PostIcon } from "../../assets/svg/svgForums";

export default function Blogbubble() {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isOpen]);

  return (
    <div className="relative">
      {isOpen && (
        <>
          <div
            className="fixed inset-0 bg-black/80 backdrop-blur-sm animate-fadeIn"
            onClick={() => setIsOpen(false)}
          ></div>
          <div
            ref={menuRef}
            className="flex flex-col items-end w-[fit-content] left-[50px] absolute top-0 z-10 max-md:left-[-230px] animate-slideUp"
          >
            <div className="bg-black/90 border border-cyan-400/50 rounded-2xl shadow-neon-cyan backdrop-blur-md overflow-hidden">
              {/* Decorative top border */}
              <div className="h-1 bg-gradient-to-r from-transparent via-cyan-400 to-transparent animate-slide-right"></div>
              
              <ul className="w-[fit-content] flex flex-col divide-y divide-gray-700/50 whitespace-nowrap">
                <li className="group relative text-cyan-100 text-sm p-4 hover:bg-cyan-400/10 transition-all duration-300 cursor-pointer overflow-hidden">
                  <div className="absolute left-0 top-0 w-1 h-0 bg-cyan-400 group-hover:h-full transition-all duration-300"></div>
                  <span className="font-mono pl-2">
                    <span className="text-cyan-400 text-xs">{'>'}</span> [RESEARCH_PROTOCOLS]
                  </span>
                </li>
                <li className="group relative text-green-100 text-sm p-4 hover:bg-green-400/10 transition-all duration-300 cursor-pointer overflow-hidden">
                  <div className="absolute left-0 top-0 w-1 h-0 bg-green-400 group-hover:h-full transition-all duration-300"></div>
                  <span className="font-mono pl-2">
                    <span className="text-green-400 text-xs">{'>'}</span> [KNOWLEDGE_MATRIX]
                  </span>
                </li>
                <li className="group relative text-pink-100 text-sm p-4 hover:bg-pink-400/10 transition-all duration-300 cursor-pointer overflow-hidden">
                  <div className="absolute left-0 top-0 w-1 h-0 bg-pink-400 group-hover:h-full transition-all duration-300"></div>
                  <span className="font-mono pl-2">
                    <span className="text-pink-400 text-xs">{'>'}</span> [NEURAL_ENHANCEMENT]
                  </span>
                </li>
                <li className="group relative text-purple-100 text-sm p-4 hover:bg-purple-400/10 transition-all duration-300 cursor-pointer overflow-hidden">
                  <div className="absolute left-0 top-0 w-1 h-0 bg-purple-400 group-hover:h-full transition-all duration-300"></div>
                  <span className="font-mono pl-2">
                    <span className="text-purple-400 text-xs">{'>'}</span> [STUDY_OPTIMIZATION]
                  </span>
                </li>
              </ul>
            </div>
            
            <button className="group relative w-[fit-content] text-sm gap-2 flex justify-center items-center p-3 bg-black/80 border border-green-400/50 mt-3 rounded-xl shadow-neon-green text-green-300 hover:text-green-100 font-mono font-medium whitespace-nowrap transition-all duration-300 transform hover:scale-105 backdrop-blur-sm">
              <PostIcon className="w-4 h-4" />
              [CREATE_POST]
              <div className="absolute inset-0 border border-green-400/30 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 animate-border-pulse"></div>
            </button>
          </div>
        </>
      )}
      <button
        className="group relative flex justify-center items-center p-4 bg-black/60 border border-cyan-400/50 rounded-2xl shadow-neon-cyan cursor-pointer z-10 transition-all duration-300 transform hover:scale-110 backdrop-blur-sm"
        onClick={toggleMenu}
      >
        <Folder className="fill-cyan-400 w-5 h-5 group-hover:fill-cyan-300 transition-colors duration-300" />
        <div className="absolute inset-0 border border-cyan-400/30 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 animate-border-pulse"></div>
        
        {/* Decorative elements */}
        <div className="absolute -top-1 -right-1 w-2 h-2 bg-cyan-400 rounded-full animate-pulse"></div>
        <div className="absolute -bottom-1 -left-1 w-1.5 h-1.5 bg-green-400 rounded-full animate-pulse delay-500"></div>
      </button>
    </div>
  );
}
